'use strict';

const storeLocator = require('base/storeLocator/storeLocator');
const utils = require('../utils/utils');

function getStoresFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('stores') || null;
}

/**
 * Get the current refinements from the url
 * @param {Array} excludeRefinements - refinements to exclude
 * @returns {Object}
 */
function getCurrentRefinements(excludeRefinements = []) {
    var queryString = '';
    var $storeRefineButton = $('.store-refine-button').first();
    var refineUrl = $storeRefineButton.data('href');
    if (refineUrl) {
        if (refineUrl.indexOf('?') !== -1) {
            queryString = refineUrl.substring(refineUrl.indexOf('?'));
        }
    }

    // create params object from queryString
    var params = {};
    if (queryString) {
        var paramString = queryString.substring(1);
        var paramPairs = paramString.split('&');

        // process each key-value pair
        paramPairs.forEach(function(pair) {
            var parts = pair.split('=');
            if (parts.length === 2) {
                var key = decodeURIComponent(parts[0]);
                var value = decodeURIComponent(parts[1]);

                // only add the parameter if it's not in the excludeRefinements array
                if (excludeRefinements.indexOf(key) === -1) {
                    params[key] = value;
                }
            }
        });
    }

    return params;
}

/**
 * remove the store selector modal when a store is selected out of results
 */
function closeChangeStoreModal() {
    if ($('#changeStoreModal').length > 0) {
        $('#changeStoreModal').modal('hide');
        $('#changeStoreModal').remove();
    }
}

/**
 * Generates the modal window on the first call.
 */
function getModalHtmlElement() {
    if ($('#changeStoreModal').length > 0) {
        $('#changeStoreModal').remove();
    }
    var htmlString = `
        <!-- Modal -->
        <div class="modal" id="changeStoreModal" role="dialog">
            <div class="modal-dialog change-store-dialog modal-lg modal-dialog-centered">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header justify-content-end">
                        <button type="button" class="close pull-right" data-dismiss="modal" title="${$('.change-store-container').data('modal-close-text')}">&times;
                        </button>
                    </div>
                    <div class="modal-body"></div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
        `;

    $('body').append(htmlString);
    $('#changeStoreModal').modal('show');
}

/**
 * Replaces the content in the modal window with find stores components and the result store list.
 * @param {string} actionUrl - URL endpoint
 * @param {number} selectedPostalCode - The postal code to search for inventory
 * @param {number} selectedRadius - The radius to search for inventory
 */
function fillModalElement(actionUrl, selectedPostalCode, selectedRadius) {
    var requestData = {};
    if (selectedRadius) requestData.radius = selectedRadius;
    if (selectedPostalCode) requestData.postalCode = selectedPostalCode;
    if (!actionUrl) return;

    $('#changeStoreModal').spinner().start();
    $.ajax({
        url: actionUrl,
        method: 'GET',
        success: function (response) {
            $('#changeStoreModal .modal-body').empty();
            $('#changeStoreModal .modal-body').html(response.storesResultsHtml);
            storeLocator.search();
            storeLocator.changeRadius();
            storeLocator.selectStore();
            storeLocator.updateSelectStoreButton();

            if (selectedRadius) {
                $('#radius').val(selectedRadius);
            }

            if (selectedPostalCode) {
                $('#store-postal-code').val(selectedPostalCode);
            }

            if (!$('.results').data('has-results')) {
                $('.store-locator-no-results').show();
            }

            $('#changeStoreModal').modal('show');
        },
        complete: function () {
            $('#changeStoreModal').spinner().stop();
        }
    });
}

/**
 * once a store is selected, update shop by store refinement, and auto-select refinement
 * @param {Object} data - set store response
 */
function filterByStore(data) {
    if (!data.storeId || !data.storeName) return;

    // find the specific store refinement button that matches the storeId
    var $storeRefineButton = $('.store-refine-' + data.storeId);

    if ($storeRefineButton.length) {
        // trigger the click to apply the refinement
        $storeRefineButton.removeClass('disabled d-none').click();
    }
}

/**
 * Updates the store refinements after a new store/location is selected from the store locator modal
 * @param {Object} data - set store response
 */
function updateStoreRefinements(data) {
    var qsParams = getCurrentRefinements(['stores']);
    qsParams.storeId = data.storeId;

    var url = $('.change-store-container').data('update-store-refinements-url');
    if (url) {
        url = utils.appendToUrl(url, qsParams);

        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                if (response && response.storeRefinementHtml) {
                    $('#refinement-shop-by-store').empty().html(response.storeRefinementHtml);
                    filterByStore(data);
                }
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    }
}

function getStoreAvailableText(storeName) {
    const inStockText = $('.change-store-container').data('tile-store-available-text') || 'Available at';
    return `<div class="text-success">
                <small>
                    <i class="fa fa-check-circle"></i> ${inStockText} ${storeName}
                </small>
            </div>`;
}

/**
 * Check store availability for all product tiles on the page
 */
function updateProductTileStoreAvailability() {
    // get selected store ids
    const stores = getStoresFromUrl();
    if (!stores) return;

    var url = $('.change-store-container').data('check-availability-url');
    if (!url) return;

    // pull all currently applied refinements
    var qsParams = getCurrentRefinements(['stores']);

    // collect all product IDs from the page
    const productIds = [];
    const productTiles = {};

    $('.product-grid .product').each(function() {
        var $productTile = $(this);
        var pid = $productTile.data('pid');

        if (!pid) return;

        // check if availability element already exists
        if ($productTile.find('.store-availability').length) {
            return;
        }

        // add to collection
        productIds.push(pid);
        productTiles[pid] = $productTile;

        // create placeholder for store availability
        var $availabilityContainer = $('<div class="store-availability mt-1"></div>');
        $productTile.find('.tile-body').append($availabilityContainer);
    });

    // if no products to check, exit
    if (productIds.length === 0) return;

    // if there is only one store, display an availability message on all tiles, skip server request
    if (stores.split('|').length === 1) {
        // get the store name from the label inside the refinement
        const storeId = stores.split('|')[0];
        const $storeRefinement = $('.store-refine-' + storeId);
        const storeName = $storeRefinement.find('label.custom-control-label').text() || $storeRefinement.find('.store-refine-name').text();

        if (storeName) {
            productIds.forEach(function(pid) {
                const $productTile = productTiles[pid];
                if (!$productTile) return;

                const $availabilityContainer = $productTile.find('.store-availability');
                $availabilityContainer.html(getStoreAvailableText(storeName));
            });
        }
        return;
    }

    // make a single batch request for all products
    qsParams.pid = productIds.join('|');
    qsParams.stores = stores;
    url = utils.appendToUrl(url, qsParams);
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            if (!response.products) {
                console.error('Invalid response format from store availability check');
                return;
            }

            // update each product tile with its availability
            Object.keys(response.products).forEach(function(pid) {
                const productData = response.products[pid];
                const $productTile = productTiles[pid];

                if (!$productTile){
                    console.warn('Product tile not found for ' + pid);
                    return;
                }

                const $availabilityContainer = $productTile.find('.store-availability');

                if (productData.error) {
                    console.error('Error checking store availability for ' + pid);
                    $availabilityContainer.remove();
                    return;
                }

                if (productData.available && productData.displayStore) {
                    $availabilityContainer.html(getStoreAvailableText(productData.displayStore.name));
                } else {
                    console.log('not available for ' + pid);
                    $availabilityContainer.remove();
                }
            });
        },
        error: function () {
            console.error('Error checking store availability');
        }
    });
}

function shouldUpdateProductTileStoreAvailability() {
    var stores = getStoresFromUrl();
    if (stores && stores.length > 0) {
        updateProductTileStoreAvailability();
    }
}

module.exports = {
    changeStore: function () {
        $('body').on('click', '.store-refinement-change-store', (function () {
            getModalHtmlElement();
            fillModalElement($(this).data('action-url'), $(this).data('postal'), $(this).data('radius'));
        }));
    },

    selectStore: storeLocator.selectStore,

    storeSelection: function () {
        $('body').on('store:selected', function (e, data) {
            closeChangeStoreModal();

            var url = $('.change-store-container').data('set-store-url');
            if (url && data.storeID) {
                url = utils.appendToUrl(url, { storeId: data.storeID });
                $.spinner().start();
                $.ajax({
                    url: url,
                    method: 'GET',
                    success: function (response) {
                        updateStoreRefinements(response);
                    },
                    complete: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },

    // handle store refinement value selection
    storeFilter: function () {
        $('body').on('search:filter', function () {
            setTimeout(function() {
                shouldUpdateProductTileStoreAvailability();
            }, 1500);
        });
    },

    showMoreTiles: function () {
        $('body').on('search:showMore', function () {
            setTimeout(function() {
                shouldUpdateProductTileStoreAvailability();
            }, 1500);
        });
    },

    checkStoresSelectedOnLoad: function () {
        $('.product-grid').ready(function () {
            shouldUpdateProductTileStoreAvailability();
        });
    }
};
